import React, { useContext, useState, useEffect } from 'react';
import GlobalStateContext from "../../../../context";
import { Button, Icon, Modal, Tooltip, Popover } from 'antd';
import CreateStream from './CreateStream';
import { canUserCreateStream, remainingStreams, url } from '../../../../utils';
import { Subscribe } from "../../../../components/protected/Subscribe";
import { useHistory } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import UploadVideo from './UploadVideo';

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const NewStreamButton = (props) => {
    const { child, popup, children, block, onSave } = props
    const [state] = useContext(GlobalStateContext);
    const { features_accessible, streams } = state;
    const [showForm, setShowForm] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [type, setType] = useState(false);
    const [remainder, setRemainder] = useState(0);
    const history = useHistory()

    const handleCancel = () => {
        setShowForm(false);
    }

    const handleTypeSelect = (e) => {
        if (!canCreate) {
            return;
        }

        if (popup || !isMobile) {
            setType(e.key);
            setShowForm(true)
        } else {
            const ul = props.url || url("stream/create", true)
            history.push(ul);
        }
    }

    useEffect(() => {
        setCanCreate(canUserCreateStream(streams.length, features_accessible));
        setRemainder(remainingStreams(streams.length, features_accessible));
    }, [streams, features_accessible])

    useEffect(() => {
        // child = child || children
    }, [])

    // Modern button styling
    const getButtonClasses = () => {
        const baseClasses = "inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2";
        
        if (!canCreate) {
            return `${baseClasses} bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200`;
        }
        
        return `${baseClasses} bg-blue-600 text-white hover:bg-blue-700 border border-transparent shadow-sm hover:shadow-md`;
    }

    return (
        <>
            {props.type === "card" ? (
                <div className="event bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer" onClick={handleTypeSelect}>
                    <div className="h-full flex items-center justify-center p-6">
                        {canCreate === true ? (
                            <button
                                className="w-16 h-16 bg-blue-600 hover:bg-blue-700 text-white rounded-full flex items-center justify-center text-2xl transition-colors"
                                onClick={handleTypeSelect}
                            >
                                +
                            </button>
                        ) : (
                            <Popover
                                title="Not Allowed"
                                content={
                                    <>
                                        Sorry, your current plan does not allow you to create anymore events.
                                        <Subscribe />
                                    </>
                                }
                            >
                                <button
                                    className="w-16 h-16 bg-gray-300 text-gray-500 rounded-full flex items-center justify-center text-2xl cursor-not-allowed"
                                    onClick={handleTypeSelect}
                                >
                                    +
                                </button>
                            </Popover>
                        )}
                    </div>
                </div>
            ) : (
                <div className="flex justify-center">
                    {canCreate === true ? (
                        <button
                            id="createStreamButton"
                            className={getButtonClasses()}
                            onClick={handleTypeSelect}
                            {...props}
                        >
                            {children ? children : (
                                <>
                                    <Icon type="video-camera" className="mr-2" />
                                    Start one
                                </>
                            )}
                        </button>
                    ) : (
                        <Popover
                            title="Not Allowed"
                            content={
                                <>
                                    Allowed number of events exceeded.
                                    <div className='mt-3'>
                                        <Subscribe />
                                    </div>
                                </>
                            }
                        >
                            <button
                                id="createStreamButton"
                                className={getButtonClasses()}
                                disabled={!canCreate}
                                onClick={handleTypeSelect}
                                {...props}
                            >
                                {children ? children : (
                                    <>
                                        <Icon type="video-camera" className="mr-2" />
                                        Start one
                                    </>
                                )}
                            </button>
                        </Popover>
                    )}
                </div>
            )}

            <Modal
                visible={showForm}
                onOk={handleCancel}
                onCancel={handleCancel}
                footer={null}
                width={800}
                className="modern-modal"
            >
                <div className="p-6">
                    {props.type === "upload" ? <UploadVideo onSave={onSave} onCancel={handleCancel} /> : <CreateStream onClose={handleCancel} type={type} onSave={onSave} />}
                </div>
            </Modal>
        </>
    )
}

NewStreamButton.defaultProps = {
    block: true
}